import { Box, Card, Group, ScrollArea, Text } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import B2bTable from "components/reusable/b2bTable";
import ExportComponent from "utiles/export";
import { formatNumber } from "utiles/url";

const SupplierOrdersTable = ({ ordersList, userName, totalAmount }) => {
  const headerData = [
    {
      label: "#",
      key: "index",
      sortable: false,
      searchable: false,
      width: "5%",
      render: (_rowData, rowIndex) => <span>{rowIndex + 1}</span>,
    },
    {
      label: "Businesses Name",
      key: "business_name",
      sortable: false,
      searchable: true,
      render: (rowData) => <b>{rowData?.business?.business_name}</b>,
    },
    {
      label: "Total Net Amount",
      key: "total_net_amount",
      sortable: false,
      searchable: false,
      render: (rowData) => (
        <span>{formatNumber(rowData.total_net_amount)}</span>
      ),
    },
    {
      label: "Total Paid Amount",
      key: "total_paid_amount",
      sortable: false,
      searchable: false,
      render: (rowData) => (
        <span>{formatNumber(rowData.total_paid_amount)}</span>
      ),
    },
    {
      label: "Remaining Amount",
      key: "remaining_amount",
      sortable: false,
      searchable: false,
      render: (rowData) => (
        <span>{formatNumber(rowData.remaining_amount)}</span>
      ),
    },
  ];

  const { height } = useViewportSize();
  const computedTotal =
    totalAmount ??
    (ordersList || []).reduce(
      (sum, row) => sum + (row.total_net_amount || 0),
      0,
    );

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <Group position="apart" align="center" mb="sm" px="xs">
        <Box>
          {userName && (
            <Text weight={700} size="lg">
              {userName}
            </Text>
          )}
          <Text weight={600} size="md" color="dimmed">
            Transactions
          </Text>
        </Box>
        <ExportComponent
          data={ordersList || []}
          headers={headerData}
          reportTitle="Supplier Orders Detail"
          fileNamePrefix={`supplier_${userName || "detail"}_orders`}
          userName={userName}
          totalAmount={formatNumber(computedTotal)}
        />
      </Group>

      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <Card shadow="sm" p="lg">
          <ScrollArea>
            <B2bTable
              header={headerData}
              data={ordersList || []}
              layout={{ minWidth: 700 }}
              total={1}
              searchInput={false}
              activePage={1}
              loading={false}
            />
          </ScrollArea>
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "12px",
              paddingRight: "8px",
            }}
          >
            <Text weight={700} size="sm">
              Total Amount: {formatNumber(computedTotal)}
            </Text>
          </Box>
        </Card>
      </ScrollArea>
    </div>
  );
};

export default SupplierOrdersTable;
